import * as types from '../const/action.types';
import { get, put, post, del } from '../api/_basic';

export function loadMachines(local) {
    return async (dispatch) => {
        dispatch(machinesHasErrored(false, ''));
        dispatch(machinesIsLoading(true));
        return get(`${process.env.REACT_APP_API_LOCAL}/${local}/maquina`)
            .then((response) => {
                dispatch(machinesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(machinesHasErrored(false, ''));
                dispatch(loadMachinesSuccess(items));
            })
            .catch((error) => {
                dispatch(machinesIsLoading(false));
                dispatch(machinesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addMachine(machine) {
    return async (dispatch) => {
        dispatch(machineIsSaving(true));
        return post(`${process.env.REACT_APP_API_MACHINE}`, machine)
            .then((response) => {
                dispatch(machineIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function editMachine(machine) {
    return async (dispatch) => {
        dispatch(machineIsSaving(true));
        return put(`${process.env.REACT_APP_API_MACHINE}/${machine.id}`, machine)
            .then((response) => {
                dispatch(machineIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function deleteMachine(machine) {
    return async (dispatch) => {
        return del(`${process.env.REACT_APP_API_MACHINE}/${machine}`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadInfo(machine) {
    return async function(dispatch) {
        dispatch(machinesHasErrored(false, ''));
        dispatch(machinesIsLoading(true));
        return get(`${process.env.REACT_APP_API_MACHINE}/${machine}`)
            .then((response) => {
                dispatch(machinesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(machinesHasErrored(false, ''));
                dispatch(loadMachineSuccess(item));
            })
            .catch((error) => {
                dispatch(machinesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function status(id, active, message) {
    return async (dispatch) => {
        return put(
            `${process.env.REACT_APP_API_MACHINE}/${id}/` + (active ? 'activar' : 'desactivar'),
            { comentario: message },
        )
            .then((response) => {
                dispatch(machinesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function pause(id, time, message) {
    return async (dispatch) => {
        return put(`${process.env.REACT_APP_API_MACHINE}/${id}/pausar`, {
            minutos: time,
            comentario: message,
        })
            .then((response) => {
                dispatch(machinesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function changeMachine(id, name, type) {
    return async (dispatch) => {
        return put(`${process.env.REACT_APP_API_MACHINE}/${id}/tipo`, {
            nombre: name,
            idTipomaquina: type,
        })
            .then((response) => {
                dispatch(machinesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadMachineSuccess(data) {
    return {
        type: types.LOAD_MACHINE_SUCCESS,
        data,
    };
}

export function loadMachinesSuccess(data) {
    return {
        type: types.MACHINES_SUCCESS,
        data,
    };
}

export function machinesHasErrored(bool, message) {
    return {
        type: types.MACHINES_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function machinesIsLoading(bool) {
    return {
        type: types.MACHINES_IS_LOADING,
        isLoading: bool,
    };
}

export function machineIsSaving(bool) {
    return {
        type: types.MACHINES_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/machine.actions.js